import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="border-t border-ink-200 bg-paper mt-24">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 grid md:grid-cols-4 gap-10">
                <div>
                    <div className="font-heading font-extrabold tracking-tightest text-2xl">SocietyIntent</div>
                    <p className="text-sm text-ink-600 mt-3 leading-relaxed max-w-xs">
                        A research collective. Members earn cash for their opinions; brands learn from real people.
                    </p>
                    <p className="font-mono text-[10px] mt-4 text-ink-600">
                        SOC.INT / EST. 2026 / NYC · TORONTO
                    </p>
                </div>
                <div>
                    <div className="eyebrow mb-3">Members</div>
                    <ul className="text-sm space-y-2">
                        <li><Link to="/register" className="hover:underline">Join free</Link></li>
                        <li><Link to="/login" className="hover:underline">Log in</Link></li>
                        <li><Link to="/faq" className="hover:underline" data-testid="footer-faq-link">FAQ</Link></li>
                        <li><Link to="/help" className="hover:underline" data-testid="footer-help-link">Help center</Link></li>
                        <li><Link to="/contact" className="hover:underline" data-testid="footer-contact-link">Contact us</Link></li>
                        <li><Link to="/legal/sms-tcpa" className="hover:underline">SMS terms</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="eyebrow mb-3">Advertisers</div>
                    <ul className="text-sm space-y-2">
                        <li><Link to="/for-advertisers" className="hover:underline" data-testid="footer-for-advertisers-link">For advertisers</Link></li>
                        <li><Link to="/register?role=advertiser" className="hover:underline">Run a study</Link></li>
                        <li><Link to="/contact" className="hover:underline">Talk to sales</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="eyebrow mb-3">Legal</div>
                    <ul className="text-sm space-y-2">
                        <li><Link to="/legal/terms" className="hover:underline">Terms of service</Link></li>
                        <li><Link to="/legal/privacy" className="hover:underline">Privacy policy</Link></li>
                        <li><Link to="/legal/sms-tcpa" className="hover:underline">SMS / TCPA</Link></li>
                        <li><Link to="/legal/cookies" className="hover:underline">Cookies</Link></li>
                        <li><Link to="/legal/aup" className="hover:underline">Acceptable use</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-ink-200 py-6 px-6 text-xs text-ink-600 flex flex-col md:flex-row gap-2 md:items-center md:justify-between max-w-7xl mx-auto">
                <span>© {new Date().getFullYear()} SocietyIntent, Inc. All rights reserved.</span>
                <span className="font-mono">USA · CANADA · MORE COUNTRIES SOON</span>
            </div>
        </footer>
    );
}
